import { TodoActionType } from "models/actionTypes/todoActionTypes";
import { TodoNavigationState } from "models/stateTypes/todoState";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const setTodoListNavigation = (state: TodoNavigationState): TodoActionType => {
  return {
    type: ReduxConstants.TodoActions.SET_LIST_NAVIGATION,
    payload: state,
  };
};

export const loadTodoNavigationItems = (items: WintSuperkollAPIModel.Todo[], totalItems: number): TodoActionType => {
  return {
    type: ReduxConstants.TodoActions.LOAD_CURRENT_NAVIGATION_ITEMS,
    payload: { items, totalItems },
  };
};

export const refreshTodoNavigationItems = (): TodoActionType => {
  return {
    type: ReduxConstants.TodoActions.REFRESH_CURRENT_NAVIGATION_ITEMS,
  };
};

export const setTodoNavigationCurrentIndex = (index: number, page: number): TodoActionType => {
  return {
    type: ReduxConstants.TodoActions.SET_CURRENT_INDEX,
    payload: { index: index, page: page },
  };
};
